import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface ModalPageTitleProps {
  title: string;
  subtitle?: string;
  titleLabel?: string;
}

export default function ModalPageTitle(props: ModalPageTitleProps) {
  const { title, subtitle, titleLabel } = props;
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: 22,
          }}
        >
          {title}
        </Typography>
        <Typography sx={{ ml: 0.5 }} variant="subtitle2">
          <Trans>{titleLabel}</Trans>
        </Typography>
      </Box>
      {subtitle && (
        <>
          <div style={{ marginBottom: '0.5rem' }} />
          <div>
            <Trans>
              <Typography variant="subtitle2">{subtitle}</Typography>
            </Trans>
          </div>
        </>
      )}
    </>
  );
}
